import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Warsaw";

export const format = (dateTime, formatString) => {
    return dayjs.utc(dateTime).tz(userTimeZone).format(formatString ?? "YYYY-MM-DD [hour:] HH:mm");
}